import {
    SUBSCRIPTION_STATUS_PAUSED,
    SUBSCRIPTION_STATUS_ACTIVE,
    SUBSCRIPTION_STATUS_CANCELLED,
} from '@/constants/Subscription';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import PostcodeService from '@/services/logistics/PostcodeService';
import router from '@/router';

const getDefaultState = () => {
    return {
        activeSubscriptionId: null,
        subscriptions: null,
        hasFetched: false,
        primaryProductTypes: [],
        plans: [
            {
                plan_name: 'Weekly',
                plan_slug: 'weekly',
            },
            {
                plan_name: 'Fortnightly',
                plan_slug: 'fortnightly',
            },
            {
                plan_name: '3 weekly',
                plan_slug: 'three-weekly',
            },
            {
                plan_name: '4 weekly',
                plan_slug: 'monthly',
            },
        ],
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState());
        },

        updateSubscriptions(state, payload) {
            state.subscriptions = payload;
        },

        setActiveSubscriptionId: (state, payload) => state.activeSubscriptionId = payload,

        setHasFetched: (state, payload) => state.hasFetched = payload,

        setProductTypes: (state, payload) => state.primaryProductTypes = payload,
    },
    actions: {
        async fetchAvailableDeliveryDay({ commit, state, rootGetters, getters }, postcode = null) {
            if (!postcode) {
                let currentSub = getters['getActiveSubscription'];
                if (!currentSub) return;
                let selectedAddress = rootGetters['address/getAddressById'](currentSub?.delivery_address_id);
                postcode = selectedAddress?.postcode;
            }
            return await new Promise(function(resolve, reject) {
                let postcodeService = new PostcodeService();
                postcodeService.getAvailableDeliveryDay(postcode)
                    .then(response => {
                        commit('setProductTypes', response.data.products);
                    })
                    .catch(error => reject(error));
            });
        },
        async fetchAllSubscriptions({ commit, state, rootGetters, dispatch }, forceReload = false) {
            if (!state.hasFetched || forceReload) {
                let service = new SubscriptionService();
                let uid = rootGetters['account/getUserId'];
                if (!uid) return;
                return await new Promise(function(resolve, reject) {
                    service.fetchAllSubscriptions(uid)
                        .then(response => {
                            commit('updateSubscriptions', response.data.data);
                            dispatch('setDefaultActiveSubscription');
                            commit('setHasFetched', true);
                            resolve(response);
                        })
                        .catch(error => {
                            commit('setHasFetched', true);
                            reject(error);
                        });
                });
            }
        },
        async updateProductType({ dispatch }, { subId, prodId, name, date }) {
            let service = new SubscriptionService();

            return await new Promise(function(resolve, reject) {
                service.updateProductType(subId, prodId, name, date)
                    .then(response => {
                        dispatch('fetchAllSubscriptions', true);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        setDefaultActiveSubscription({ commit, state, getters }) {
            if (state.activeSubscriptionId === null && getters.getActiveSubscriptions.length) {
                commit('setActiveSubscriptionId', getters.getActiveSubscriptions[0].id);
            }
        },

        resetSubscription({ commit }) {
            commit('resetState');
        },
    },
    getters: {
        allowCancel(state, getters) {
            return false;
        },

        getSubscriptions: state => state.subscriptions,

        subscriptionsHaveFetched: state => state.hasFetched,

        getActiveSubscriptions(state) {
            return state.subscriptions
                ? state.subscriptions?.filter(subscription => {
                    return subscription.status === SUBSCRIPTION_STATUS_ACTIVE || subscription.status === SUBSCRIPTION_STATUS_PAUSED;
                })
                : [];
        },
        getActiveSubscriptionId: state => state.activeSubscriptionId,

        getInactiveSubscriptions(state) {
            return state.subscriptions
                ? state.subscriptions.filter(subscription => {
                    return subscription.status === SUBSCRIPTION_STATUS_CANCELLED;
                })
                : [];
        },

        getSubscriptionById(state) {
            return subscriptionId => {
                return state.subscriptions
                    ? state.subscriptions?.find(item => {
                        return item.id === subscriptionId;
                    })
                    : {};
            };
        },

        getActiveSubscription(state, getters) {
            return state.activeSubscriptionId !== null ? getters.getSubscriptionById(state.activeSubscriptionId) : null;
        },

        getProductTypes: state => state.primaryProductTypes,

        getPausedSubscriptions(state) {
            return state.subscriptions.filter(subscription => subscription.status === SUBSCRIPTION_STATUS_PAUSED) || [];
        },

        hasMultipleActiveSubscriptions(state, getters) {
            return state.hasFetched && getters.getActiveSubscriptions.length > 1;
        },

        hasActiveSubscription(state) {
            return state.subscriptions?.find((item) => item.status === SUBSCRIPTION_STATUS_ACTIVE) !== undefined;
        },

        hasMultiplePausedSubscriptions(state, getters) {
            return getters.getPausedSubscriptions.length > 0;
        },

        getPlans: state => state.plans,
    },
};
